import {createContext} from 'react';

export const InteractionContext = createContext<InteractionState>({
    type: 'normal',
    subtype: 'normal',
});

InteractionContext.displayName = 'InteractionContext';

export const InteractionProvider = InteractionContext.Provider;
